import { PRINT_CENTER_ROUTES, PRINT_CENTER_SOURCE, URL_LOGIN } from '@/constant';
import { history } from '@umijs/max';
import { stringify } from 'querystring';

export const navLogin = (): void => {
  const urlParams = new URL(window.location.href);
  const { search, pathname } = urlParams;
  /** 此方法会跳转到 redirect 参数所在的位置 */
  const redirect = urlParams.searchParams.get('redirect');
  // 通用方法，如果已经是登录页，就不要重复跳转了
  if (pathname === URL_LOGIN || isPrintCenterFromOutside()) {
    return;
  }
  // Note: There may be security issues, please note
  if (window.location.pathname !== URL_LOGIN && !redirect) {
    history.replace({
      pathname: '/user/login',
      search: stringify({
        redirect: pathname + search,
      }),
    });
  }
};

export const navMaintenance = (): void => {
  const urlParams = new URL(window.location.href);
  const { pathname } = urlParams;

  // 如果已经是维护页面，就不要重复跳转了
  if (pathname === '/maintenance') {
    return;
  }

  // 跳转到维护页面
  history.replace({
    pathname: '/maintenance',
  });
};

export const isPrintCenterFromOutside = (): boolean => {
  const urlParams = new URL(window.location.href);
  const { pathname } = urlParams;
  const from = urlParams.searchParams.get('from') || '';
  console.log('isPrintCenterFromOutside=============', from, pathname);

  if (from && from === 'baoban') {
    const supplier = urlParams.searchParams.get('supplier') || '';
    localStorage.setItem('baoban_supplier', supplier);
    let token = decodeURIComponent(urlParams.searchParams.get('token') || '');
    // 处理app_user_name中文
    let tokenJson = JSON.parse(token);
    tokenJson.app_user_name = encodeURIComponent(tokenJson.app_user_name);
    token = JSON.stringify(tokenJson);
    localStorage.setItem('mhm_token', token);
    const shopId = urlParams.searchParams.get('shopId') || '';
    localStorage.setItem('baoban_shop_id', shopId);
  } else if (from) {
    localStorage.removeItem('baoban_supplier');
    localStorage.removeItem('mhm_token');
    localStorage.removeItem('baoban_shop_id');
  }

  const mhm_token = localStorage.getItem('mhm_token');

  return (
    (PRINT_CENTER_SOURCE.includes(from) || !!mhm_token) && pathname.includes(PRINT_CENTER_ROUTES)
  );
};
